import { Component } from "@opten/compiler/metadata/component";

@Component({ className: "js-game-evaluation" })
export class EvaluationComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener("click", () => this.evaluation());
	}

	private evaluation(): void {
		let points = 0;
		let text: Array<{ title: string | null; text: string | null }> = [];
		const buttons = document.querySelectorAll(
			".questions button.active"
		) as NodeListOf<HTMLElement>;
		buttons.forEach((btn) => {
			const dataPoint = btn.getAttribute("data-point");
			if (dataPoint) {
				points += parseFloat(dataPoint);
			}
			const dataText = btn.getAttribute("data-text");
			const dataTitle = btn.getAttribute("data-title");
			if (dataTitle || dataText) {
				text.push({ title: dataTitle, text: dataText });
			}
		});

		let pointsData = {};
		const allButtons = document.querySelectorAll(
			".questions button"
		) as NodeListOf<HTMLElement>;

		allButtons.forEach((btn) => {
			if (btn.classList.contains("active")) {
				if (pointsData[btn.innerText]) {
					pointsData[btn.innerText] += 1;
				} else {
					pointsData[btn.innerText] = 1;
				}
			}

			if (!pointsData[btn.innerText]) {
				pointsData[btn.innerText] = 0;
			}
		});

		const divs = document.querySelectorAll(
			".result[data-points]"
		) as NodeListOf<HTMLElement>;
		if (divs.length > 0) {
			divs.forEach((div) => {
				const dataPoints = div.getAttribute("data-points");
				if (dataPoints) {
					const [min, max] = dataPoints.split("-").map(Number);

					if (points >= min && points <= max) {
						div.style.display = "block";
						div.classList.add("active");
						const quizElement = document.getElementById("quiz");
						if (quizElement) {
							quizElement.style.display = "none";
						}
					}
					const summaries = div.querySelectorAll(".js-game-summary");
					const summariesDivs = div.querySelectorAll(
						".js-game-summary-insert"
					);

					if (summaries && summariesDivs.length > 0) {
						Object.keys(pointsData).forEach((name) => {
							const point = pointsData[name];
							summaries.forEach((summary, index) => {
								if (summariesDivs[index]) {
									const span = document.createElement("span");
									span.className =
										"c-quiz__evaluations__summary__button";
									span.textContent = `${point}x ${name}`;
									summariesDivs[index].appendChild(span); // Hier wird das neue Element angehängt
								}
							});
						});
					}
				}
			});
		} else {
			const div = document.querySelector(
				".c-decision__evaluations"
			) as HTMLElement;
			if (div) {
				if (text.length === 0) {
					div.querySelectorAll(".result").forEach((result) => {
						(result as HTMLElement).style.display = "block";
						(result as HTMLElement).classList.add("active");
					});
					const quizElement = document.getElementById("quiz");
					if (quizElement) {
						quizElement.style.display = "none";
					}
				} else {
					text.forEach(({ title, text }) => {
						div.innerHTML += `<div class='result'><h4>${title}</h4><p>${text}</p></div>`;
					});
					div.querySelectorAll(".result").forEach((result) => {
						if (result.classList.contains("fallback")) return;
						(result as HTMLElement).style.display = "block";
						(result as HTMLElement).classList.add("active");
					});

					const quizElement = document.getElementById("quiz");
					if (quizElement) {
						quizElement.style.display = "none";
					}
				}
			}
		}
	}
}
